import { ReactNode } from 'react';
import clsx from 'clsx';
export function Panel({ title, children, className, action }: { title?: string; children: ReactNode; className?: string; action?: ReactNode }) {
  return (
    <div className={clsx('bg-bg hairline rounded-sm', className)}>
      {title && (
        <div className="hairline-b px-3 py-2 flex items-center justify-between">
          <span className="text-xs font-medium uppercase tracking-[0.08em] text-muted">{title}</span>
          {action}
        </div>
      )}
      <div className="p-3">{children}</div>
    </div>
  );
}
